module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAGCAYAAACmekziAAAAAXNSR0IArs4c6QAAAH1JREFUKBVjbLh6le3tt/tN//8zxjEAASPj/0XCXIp1Ddrav0B8XIDa+lhAjvj3j6GcgeE/2M7//xnKgWIgdgUuR4DEqa2PCRYSyJZiE0OWB7GxqcEmRqw+JnSFA8VnAqUJdMuxiRGjhhJ9LKCECUoTsGCFJVZ0i9H51NYHABvBd6XaZI/TAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/more.png
// module id = uty8
// module chunks = 1